"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSetImpl = void 0;
var QueryContext_1 = __importDefault(require("./context/QueryContext"));
var AbstractConfigSetImpl_1 = require("./AbstractConfigSetImpl");
var ConfigSetImpl = /** @class */ (function (_super) {
    __extends(ConfigSetImpl, _super);
    function ConfigSetImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigSetImpl.prototype.getBoolean = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImpl.prototype.getString = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImpl.prototype.getInteger = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImpl.prototype.getList = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    ConfigSetImpl.prototype.getObject = function (key, context, weblabContext) {
        return this.configStoreProxy.getValue(key, context !== null && context !== void 0 ? context : new QueryContext_1.default(), weblabContext);
    };
    // Disabled as those variables will be used while implementing wildcard query support.
    /* eslint-disable @typescript-eslint/no-unused-vars */
    ConfigSetImpl.prototype.listBoolean = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImpl.prototype.listInteger = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImpl.prototype.listList = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImpl.prototype.listObject = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    ConfigSetImpl.prototype.listString = function (key, context, weblabContext) {
        throw new Error(this.LISTING_IS_NOT_SUPPORTED);
    };
    return ConfigSetImpl;
}(AbstractConfigSetImpl_1.AbstractConfigSetImpl));
exports.ConfigSetImpl = ConfigSetImpl;
